<template>
    <v-container class="d-flex justify-center">
        <ReportDialog v-if="Show" :show = "Show" :ReportSucces="Success" :DataFound="DataNotFound" @closeSuccessDialog="closeSuccessDialog"/>
        <v-card class="mt-40 v-card-width" elevation="0">
            <img class = "back_image" src = "/img/arrow_back.svg" @click="goBack"/>
            <div class="div-margin">
                <v-row class = "width-short">
                    <v-col>
                        <h5 class="heading" style="font-size:22px">Reports</h5>
                    </v-col>
                </v-row>
                <ValidationObserver v-slot="{ invalid }">
                    <ValidationProvider
                        name="ReportSelect"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-row>
                            <v-select
                                :items="itemsReport"
                                label="Select the report"
                                dense
                                outlined
                                solo
                                v-model="selectedReport"
                                :error-messages="errors"
                                @change = "reset"
                            ></v-select>
                        </v-row>
                    </ValidationProvider>
                    <ValidationProvider
                        name="DateSelect"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-row>
                            <v-select
                                :items="itemsDate"
                                label="Select date range"
                                dense
                                outlined
                                solo
                                v-model="selectedDate"
                                :error-messages="errors"
                                @change = 'resetDateRange'
                                mode="passive"
                                :disabled="disabledDate"
                            ></v-select>
                        </v-row>
                    </ValidationProvider>
                    <v-row v-if="selectedDate === 'Custom'">
                        <div class="select">Select Date Range</div>
                    </v-row>
                    <v-row v-if="selectedDate === 'Custom'" class="datesRow">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider
                                    name="DateFrom"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <v-text-field
                                        v-model="dateFrom"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        dense
                                        solo
                                        :error-messages="errors"
                                        label="dd/mm/yyyy"
                                        class="from"
                                    ></v-text-field>
                                </ValidationProvider>
                            </template>
                            <v-date-picker
                                v-model="dateFrom"
                                no-title
                                scrollable
                                @input="menu = false"
                                :allowed-dates="disableBeforeSpecificDates"
                            >
                            </v-date-picker>
                        </v-menu>
                        <p class="to">To</p>
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider
                                    name="DateTo"
                                    :rules="`required|after:${dateFrom}`"
                                    v-slot="{ errors }"
                                >
                                    <v-text-field
                                        v-model="dateTo"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        dense
                                        solo
                                        :error-messages="errors"
                                        label="dd/mm/yyyy"
                                    ></v-text-field>
                                </ValidationProvider>
                            </template>
                            <v-date-picker
                                v-model="dateTo"
                                no-title
                                scrollable
                                @input="menu2 = false"
                                :allowed-dates="disableBeforeSpecificDates"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-row>
                    <v-row class="justify-center">
                        <button
                        @click="submitData"
                        :disabled = "invalid"
                        >
                            <span class="button">Download</span>
                        </button>
                    </v-row>
                </ValidationObserver>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import lenderService from '@/services/lenderService'
import ReportDialog from '@/components/dashboard/reportDialog.vue'

function getDateFormatted (date) {
    const newDate = new Date(date)
    const day = newDate.getDate()
    const month = getMonthName(newDate.getMonth() + 1)
    const year = newDate.getFullYear()
    const finalDate = '' + day + ' ' + month + ' ' + year
    return finalDate
}

function getMonthName (monthNumber) {
    const date = new Date()
    date.setMonth(monthNumber - 1)
    return date.toLocaleString('en-US', { month: 'short' })
}

export default {
    name: 'Reports',
    components: {
        ReportDialog
    },
    data () {
        return {
            menu: false,
            menu2: false,
            dateFrom: '',
            dateTo: '',
            selectedDate: '',
            selectedReport: '',
            finicalYear: '',
            link: '',
            Show: false,
            Success: false,
            disabledDate: true,
            DataNotFound: true,
            option: 0,
            itemsReport: [
                'Loan Report',
                'Earnings'
            ],
            itemsDate: [
                'Financial Year - April 2023 to March 2024',
                'Financial Year - April 2022 to March 2023',
                'Financial Year - April 2021 to March 2022',
                'From Inception',
                'Custom'
            ]
        }
    },
    watch: {
    },
    filters: {
    },
    mounted () {
    },
    methods: {
        disableBeforeSpecificDates (val) {
            return new Date(val) <= new Date() && new Date(val) >= new Date('2020-12-01')
        },
        reset () {
            this.dateFrom = ''
            this.dateTo = ''
            this.selectedDate = ''
            this.disabledDate = false
        },
        resetDateRange () {
            this.dateFrom = ''
            this.dateTo = ''
        },
        closeSuccessDialog () {
            this.Show = false
            window.location.reload()
        },
        goBack () {
            this.$router.push('/dashboard')
        },
        async submitData () {
            this.$store.commit('isLoading')
            if (this.selectedDate === 'Financial Year - April 2022 to March 2023') {
                this.dateTo = '2023-03-31'
                this.dateFrom = '2022-04-01'
                this.finicalYear = 'April 2022 to March 2023'
            } else if (this.selectedDate === 'Financial Year - April 2021 to March 2022') {
                this.dateTo = '2022-03-31'
                this.dateFrom = '2021-04-01'
                this.finicalYear = 'April 2021 to March 2022'
            } else if (this.selectedDate === 'Financial Year - April 2023 to March 2024') {
                this.dateTo = '2024-03-31'
                this.dateFrom = '2023-04-01'
                this.finicalYear = 'April 2023 to March 2024'
            } else if (this.selectedDate === 'From Inception') {
                this.dateTo = new Date()
                this.dateFrom = '2021-12-01'
                this.option = 1
                this.finicalYear = getDateFormatted(this.dateFrom) + ' to ' + getDateFormatted(this.dateTo)
            } else if (this.selectedDate === 'Custom') {
                this.finicalYear = getDateFormatted(this.dateFrom) + ' to ' + getDateFormatted(this.dateTo)
                this.option = 2
            }
            const query = 'fromDate=' + this.dateFrom + '&toDate=' + this.dateTo + '&ficialYear=' + this.finicalYear + '&option=' + this.option
            try {
                if (this.selectedReport === 'Earnings') {
                    const res = await lenderService.getLenderEarningReportPDF(query)
                    if (res.status === 200) {
                        this.Show = true
                        this.Success = true
                        const link = document.createElement('a')
                        link.href = res.data.path
                        link.click()
                    } else {
                        if (res.data.Error === 'No data found') {
                            this.Show = true
                            this.Success = false
                            this.DataNotFound = true
                        }
                        this.Show = true
                        this.Success = false
                    }
                } else if (this.selectedReport === 'Loan Report') {
                    var res = await lenderService.getLenderLoanReportPDF(query)
                    if (res.status === 200) {
                        this.Show = true
                        this.Success = true
                        const link = document.createElement('a')
                        link.href = res.data.path
                        link.click()
                    } else {
                        if (res.data.Error === 'No data found') {
                            this.Show = true
                            this.Success = false
                            this.DataNotFound = true
                        }
                        this.Show = true
                        this.Success = false
                    }
                }
            } catch (error) {
                this.Show = true
                this.Success = false
            }

            this.$store.commit('isNotLoading')
            setTimeout(() => {
                this.closeSuccessDialog()
            }, 3000)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/_dashboard-layout.scss";
.from {
    margin-right: 100px;
}
.datesRow {
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin: 0px;
    margin-top: 20px;
}
span {
    margin-left: 0px!important;
    padding-left: 0px!important;
    width: 47% !important;
    padding: 2px !important;
}
.big {
    width: 48px;
    height: 48px;
    background-color: yellow;
    border-radius: 50%;
}
.center-icon {
    color: #009E2C;
    width:50px;
}
::v-deep .v-icon {
    height:14px;
    width:59px;
    background-color: #FFFFFF;
    float:right;
}
.material-symbols-rounded {
    font-variation-settings:
        'FILL' 1,
        'wght' 400,
        'GRAD' 0,
        'opsz' 48,
}
.success-message {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 10px;
    color: #181818;
}
.message {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #475467;
}
.dialog-custom {
    background: #ffffff;
    border: 1px solid #b9b9bb !important;
    box-sizing: border-box !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 20px !important;
    max-width:30%;
    @media screen and (max-width: 400px) {
        max-width:10%;
    }
    .v-card__actions {
        padding: 20px !important;
    }
}
.to{
    color: #4F4F4F;
    font-weight: 400;
    font-size: 11px;
    margin-top: 5px;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 40px;
    width: 20px;
}
.select{
    color: #4F4F4F;
    font-weight: 400;
    font-size: 15px;
}
.heading {
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    padding: 0px !important;
}
h5{
    margin-bottom: 20px;
}
.v-text-field{
    height:80px !important;
    width: 100%;
}
::v-deep .v-input__slot {
    background-color: #F7FAFF !important;
    border: 1px solid #C8DEFF;
    border-radius: 4px;
    width:100%;
    box-shadow: none !important;
    height: 60px !important;
    max-height: 0px !important;
}
::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot{
    height : 40px !important;
}
::v-deep .v-menu__content, .menuable__content__active {
    min-width: unset !important;
}
::v-deep .menuable__content__active{
    top: 251px !important;
    max-width: none !important;
    left: 0px !important;
}

.v-card-width{
    width: 70%;
}
.div-margin{
    margin-left: 150px;
    margin-right: 150px;
    margin-top: 20px;
}
button{
    justify-content: center;
    align-items: center;
    padding: 13px 120px;
    position: absolute;
    width: 332px;
    height: 50px;
    background: #002FA7;
    border-radius: 6px;
}
:disabled {
    background: rgba(0, 47, 167, 0.4);
}
.button{
    color: #FFFFFF;
}
@media (max-width: 400px) {
    button {
        padding: 13px 80px !important;
    }

}
@media (max-width: 720px) {

    ::v-deep .v-menu__content {
        max-width: none !important;
    }
    span {
        width: 43% !important;
    }
    .to{
        color: #4F4F4F;
        font-weight: 400;
        font-size: 11px;
        margin-top: 5px;
        margin-left: 8px;
        margin-right: 8px;
        margin-bottom: 40px;
        width: 20px;
    }
    .div-margin{
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 20px;
    }
    .v-card-width{
        width: 100%;
    }
    ::v-deep .v-input__slot {
        background-color: #F7FAFF !important;
        border: 1px solid #C8DEFF;
        border-radius: 4px;
        width:100%;
    }
    ::v-deep .v-input__control .v-input__slot {
        box-shadow: 0px;
    }
    .datesRow {
        width:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px;
        margin: 0px;
        margin-top: 20px
    }
    span {
        max-width: 50% !important;
        padding: 2px !important;
    }
    button {
        justify-content: center;
        align-items: center;
        padding: 13px 120px;
        position: absolute;
        width: 95%;
        height: 50px;
        background: #002FA7;
        border-radius: 6px;
    }
}
@media  (min-width: 600px) and (max-width: 900px) {

    span {
        width: 43% !important;
    }
    .v-card-width{
        width: 80%;
    }
    button {
        justify-content: center;
        align-items: center;
        padding: 13px ;
        position: absolute;
        width: 60%;
        height: 50px;
        background: #002FA7;
        border-radius: 6px;
    }
}
@media  (min-width: 901px) and (max-width: 1320px) {
    span {
        width: 40% !important;
    }
}
</style>
